import { render, staticRenderFns } from "./lite-favorite.vue?vue&type=template&id=54dd9d5e&"
import script from "./lite-favorite.vue?vue&type=script&lang=js&"
export * from "./lite-favorite.vue?vue&type=script&lang=js&"
import style0 from "./lite-favorite.vue?vue&type=style&index=0&id=54dd9d5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports